import { UserEventMessage, UserEventMessageType, UserEventType, UserOwnedLobbiesData } from '@playcastdotio/Messaging';
import { userEventsState } from '../../../stores/shared';

export const handleUserEventsMessage = (message: UserEventMessage) => {
  console.log('Received user events message:', message);
  if (message.type === UserEventMessageType.USEREVENT_FETCH_RESPONSE) {
    userEventsState.updateState({
      ownedLobbies:
        (message.events.find((event) => event.eventType === UserEventType.USER_OWNED_LOBBIES)?.eventData as UserOwnedLobbiesData)
          ?.ownedLobbies || null,
    });
  } else if (message.type === UserEventMessageType.USEREVENT_SERVER_PUSH) {
    if (message.eventType === UserEventType.USER_OWNED_LOBBIES) {
      userEventsState.updateState({
        ownedLobbies: (message.eventData as UserOwnedLobbiesData)?.ownedLobbies || null,
      });
    }
  }
};
